import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

const TermsAndPolicyModal = ({ title, children, footer, modalStatus, modalActiveStatus, showCloseButton = true }) => {
    const [show, setShow] = useState(false);
    const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
    const bodyRef = useRef(null);

    useEffect(() => {
        setShow(modalStatus);
        setHasScrolledToBottom(false);
        return () => { setShow(false); }
    }, [modalStatus]);

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 10) {
            setHasScrolledToBottom(true);
        }
    };

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header style={{ backgroundColor: '#294561', height: '50px' }}>
                <Modal.Title className='text-light'>{title}</Modal.Title>
                {showCloseButton && (
                    <FontAwesomeIcon
                        onClick={() => modalActiveStatus(false)}
                        icon={faXmark}
                        className='au-modal-close-btn'
                        style={{ color: '#ffffff' }}
                    />
                )}
            </Modal.Header>
            <Modal.Body className="terms-policy-modal-body" ref={bodyRef} onScroll={handleScroll}>
                {children}
            </Modal.Body>
            <Modal.Footer>
                {typeof footer === 'function' ? footer(hasScrolledToBottom) : footer}
            </Modal.Footer>
        </Modal>
    )
}
export default TermsAndPolicyModal;
